export default "__VITE_ASSET__KZB4c08t__"